module.exports = __webpack_public_path__ + "static/logo-behoerdenarzt-0b6726212bd93294a75e098528dc7b5e.png";